import { Component, OnInit } from "@angular/core";
import { AppstorageTsService } from "src/app/services/appstorage/appstorage.ts.service";
import { AudioService } from "src/app/services/audio/audio.service";

@Component({
  selector: 'app-sound-switch',
  templateUrl: './sound-switch.component.html',
  styleUrls: ['./sound-switch.component.scss'],
})

export class SoundSwitchComponent implements OnInit {

  private audioStatus: boolean = this.audioService.isAudioOn;

  constructor(
    private audioService: AudioService,
    private appStorageService: AppstorageTsService,
  ) { }

  ngOnInit(): void {

  }

  protected onToggleAudio($event?: boolean): any {
    const tempAudioStatus = this.audioStatus;
    this.audioStatus = !tempAudioStatus;
    this.audioService.isAudioOn = this.audioStatus;
    this.appStorageService.setAudioOn(this.audioStatus);

    if(this.audioStatus) return this.audioService.playMusic("BGMusic");
    return this.audioService.stopMusic();
  }
}